module.exports = __webpack_public_path__ + "img/happy_kids.adf98134.png";